import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';

export default function SingleCocktail() {
  const { productId } = useParams();
  const [product, setProduct] = useState([]);
  console.log(useParams());

  useEffect(() => {
    async function getProduct() {
      try {
        const response = await fetch(
          `https://sheltered-badlands-71188.herokuapp.com/api/v1/product/${productId}`
        );
        const data = await response.json();
        console.log(data);
        if (data) {
          setProduct(data);
        } else {
          setProduct([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
    getProduct();
  }, [productId]);

  if (!product) {
    return <h2 className=''>No Product to Display</h2>;
  } else {
    const { name, image, description, brand, price, countInStock } = product;
    return (
      <Container className=''>
        <div className='sproduct-details'>
          <div className=''>
            <img className='sproduct-image' src={image} alt={name}></img>
          </div>
          <div className=''>
            <h2 className='sproduct-text'>{name}</h2>
            <p className='sproduct-text2'>
              <span className='sproduct-text'>Name :</span> {name}
            </p>
            <p className='sproduct-text2'>
              <span className='sproduct-text'>Brand :</span> {brand}
            </p>
            <p className='sproduct-text2'>
              <span className='sproduct-text'>Description :</span> {description}
            </p>
            <p className='sproduct-text2'>
              <span className='sproduct-text'>Price :</span> {price}
            </p>
            <p className='sproduct-text2'>
              <span className='sproduct-text'>Stock :</span> {countInStock}
            </p>
            <Link to='/shop' className='btn btn-primary'>
              back home
            </Link>
          </div>
        </div>
      </Container>
    );
  }
}
